import { createContext, useContext, useState, useEffect, useCallback } from "react";

const CartContext = createContext(null);
const KEY = "mx_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = useCallback((item) => {
    setItems((prev) => (prev.some((i) => i.media_item_id === item.media_item_id) ? prev : [...prev, item]));
  }, []);
  const remove = useCallback((id) => setItems((prev) => prev.filter((i) => i.media_item_id !== id)), []);
  const update = useCallback((id, changes) => setItems((prev) => prev.map((i) => (i.media_item_id === id ? { ...i, ...changes } : i))), []);
  const clear = useCallback(() => setItems([]), []);
  const has = useCallback((id) => items.some((i) => i.media_item_id === id), [items]);

  const subtotal = items.reduce((s, i) => s + (i.price || 0), 0);

  return (
    <CartContext.Provider value={{ items, add, remove, update, clear, has, count: items.length, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
